import { render } from "./EndInfoSet.vue?vue&type=template&id=267ef8a2"
import script from "./EndInfoSet.vue?vue&type=script&lang=js"
export * from "./EndInfoSet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__